import { SaleState, type Sale } from '@src/core/buyerApiClient';
import { OrderStatus, type Order } from '@src/features/orders/types';

import type { ConfirmationTarget } from '../components/types';

// The sale or order still waiting on the supplier, if any. The sale is checked first: on a sale-type direct link
// it is the purchase itself, while in the order flow a sale only exists once the order is confirmed and paid.
export const awaitingConfirmationTarget = (
  order: Order | null | undefined,
  sale: Sale | null | undefined,
): ConfirmationTarget | undefined => {
  if (sale?.state === SaleState.AwaitingConfirmation) {
    return { type: 'sale', id: sale.id };
  }

  if (order?.status === OrderStatus.AwaitingConfirmation) {
    return { type: 'order', id: order.id };
  }

  return undefined;
};
